import Vue from 'vue'
import VueAMap from 'vue-amap'
import ElementUI from 'element-ui'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './plugins/moment.js'
import './plugins/axios.js'
import './plugins/common.js'
import './utils/rem'
import 'normalize.css'// A modern alternative to CSS resets
import './styles/c.less'
import './components'
import './filter'

Vue.use(ElementUI)
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: 'bff22e3ec79d523c9ac949adb80847f7',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geocoder', 'AMap.Geolocation'],
  v: '1.4.5'
})

Vue.config.productionTip = false

new Vue({
	router,
  store,
  render: h => h(App),
}).$mount('#app')
